import React, { useContext, useEffect, useState } from "react";
import { DEFAULT_LIMIT } from "../../../constants";
import styled from "styled-components";
import PaginationWrapper from "../../../components/shared/pagination/PaginationWrapper";
import FilterContent from "./filters-table/FilterContent";
import { Grid } from "@mui/material";
import Search from "../../../components/shared/Search";
import { BookingAccessControlContext } from "../booking-access-control/BookingAccessControlContext";

const MainContainer = styled.div`
  margin-top: 0.25rem;
  width: 100%;
`;

const TopBarStyle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const initialValues = {
    fetching: false,
    prevTokens: [],
    nextToken: null,
    nextData: 0,
    limit: DEFAULT_LIMIT,
    data: [],
    sortDirection: "ASC",
    orderBy: "filterName",
    refreshData: 0,
};

const FilterMainPage = ({ showMyFilters, registerUpdateFn, registerTriggerFetch }) => {
    const { groupSearchEvent } = useContext(BookingAccessControlContext);
    const [searchAssignedGroup, setSearchAssignedGroup] = useState("");

    useEffect(() => {
        setSearchAssignedGroup(groupSearchEvent?.query || "");
    }, [groupSearchEvent?.version, groupSearchEvent?.query]);

    return (
        <MainContainer>
            <Grid container spacing={3}>
                <Grid item md={12}>
                    <TopBarStyle>
                        <Search
                            setQuery={setSearchAssignedGroup}
                            label={"Search for assigned group"}
                            size={"325px"}
                            externalQuery={searchAssignedGroup}
                        />
                    </TopBarStyle>
                    <PaginationWrapper initialValues={initialValues}>
                        <FilterContent
                            showMyFilters={showMyFilters}
                            registerTriggerFetch={registerTriggerFetch}
                            registerUpdateFn={registerUpdateFn}
                            searchAssignedGroup={searchAssignedGroup}
                        />
                    </PaginationWrapper>
                </Grid>
            </Grid>
        </MainContainer>
    );
};

export default FilterMainPage;
